var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticStyle:{"cursor":"pointer"},attrs:{"color":_vm.color}},'v-icon',attrs,false),on),[_vm._v(" mdi-"+_vm._s(_vm.icon)+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.hint))])])}
var staticRenderFns = []

export { render, staticRenderFns }